import { getCurrentInstance, ref } from 'vue'
import { defineStore } from 'pinia'
import { PAGINATION_LIMIT } from '@/configs/config'
import File from '@/models/File'

export const useStorageStore = defineStore('storageStore', () => {
  const instance = getCurrentInstance()
  const { $api, $toast } = instance.appContext.config.globalProperties

  const objects = ref([])
  const files = ref([])
  const loading = ref(false)
  const error = ref(false)
  const pathname = ref('/')
  const pagination = { limit: PAGINATION_LIMIT, from: null, sort: '-time' }
  // const filter = { type: 'video', filter: '1080p' } // TODO использовать в будущем

  const getFiles = async () => {
    if (loading.value) return
    loading.value = true

    try {
      const res = await $api.getObjects({ path: pathname.value, ...pagination.value })

      const data = res.data

      objects.value = data?.contents ? data.contents.map(item => new File(item)) : []

      if (objects.value.length <= 0) files.value = []

      const d = objects.value.filter(file => file.isDir)
      const f = objects.value.filter(file => !file.isDir)

      files.value = [...d, ...f]
    } catch (err) {
      const code = err?.response?.status
      let msg = 'При загрузке файлов произошла ошибка'

      if (code === 403) {
        msg = 'Недостаточно прав, обратитесь к администратору.'
      }

      $toast?.show({
        text: msg,
        lifetime: 2500
      })
    } finally {
      loading.value = false
    }
  }

  const searchFiles = async (fileName) => {
    if (loading.value) return
    loading.value = true

    try {
      const res = await $api.findObjects({
        name: fileName,
        description: 'name'
        // not_regex: true
      })

      const data = res.data

      objects.value = data?.objects ? data.objects.map(item => new File(item)) : []

      if (objects.value.length <= 0) files.value = []

      const d = objects.value.filter(file => file.isDir)
      const f = objects.value.filter(file => !file.isDir)

      files.value = [...d, ...f]
    } catch (err) {
      const code = err?.response?.status
      let msg = 'При загрузке файлов произошла ошибка'

      if (code === 403) {
        msg = 'Недостаточно прав, обратитесь к администратору.'
      }

      $toast?.show({
        text: msg,
        lifetime: 2500
      })
    } finally {
      loading.value = false
    }
  }

  return {
    objects,
    files,
    error,
    loading,
    pathname,
    getFiles,
    searchFiles
  }
})
